import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c82b386"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-lg ecran-container" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = {
  key: 0,
  class: "app__page__title__container"
}
const _hoisted_4 = {
  class: "app__page__title",
  style: {"white-space":"nowrap"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Documente")
const _hoisted_6 = { class: "dashboard__document__details" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "app__label--small" }, "Tip Document", -1))
const _hoisted_8 = { class: "app__color--blue" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "app__label--small" }, "Data", -1))
const _hoisted_10 = { class: "app__property--small" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "app__label--small" }, "Id", -1))
const _hoisted_12 = { class: "app__property--small" }
const _hoisted_13 = { class: "dashboard__document__icons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$q.platform.is.desktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_q_icon, {
                name: "description",
                style: {"font-size":"2rem","top":"-3px"},
                color: "#273233"
              }),
              _hoisted_5
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrDocuments, (document) => {
      return (_openBlock(), _createElementBlock("div", {
        key: document.appid,
        class: "dashboard__document__section app__border__bottom"
      }, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, _toDisplayString(document.tipDocument), 1),
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(document.dataDocument), 1),
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, _toDisplayString(document.idDocument), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_q_icon, {
            name: "download",
            style: {"color":"#2C88D9","font-size":"1.7rem"}
          }),
          _createVNode(_component_q_icon, {
            name: "search",
            style: {"color":"#F7C325","font-size":"1.7rem"}
          })
        ])
      ]))
    }), 128))
  ]))
}